<template>
<!-- Site wrapper -->
  <div class="form-row">
    <div class="form-group col-md-6 col-lg-6 col-xl-6">
      <label for="inputOAB" class="required">OAB</label>
      <input
        type="text"
        class="form-control"
        v-model="dadosPerfil.f_oab"
        :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
        id="inputOAB">
      <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_profile_data.f_oab']}}</div>
    </div>
    <div class="form-group col-md-12 col-xl-6">
      <label for="inputCoordenador" class="required">Coordenador</label>
      <v-select
        class="style-chooser"
        v-model="dadosPerfil.coordinator"
        @search="eventoDigitarBuscaPorCoordenador"
        :options="comboCoordenadoresDisponiveis"
        :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
        :filterable="false">
        <template v-slot:no-options>
          <em>Nenhum registro encontrado.</em>
        </template>
      </v-select>
      <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_profile_data.f_coordinator']}}</div>
    </div>
    <div class="agrupamento col-xl-12">
      <div class="form-row col-xl-12">
        <div class="form-group col-sm-12 col-md-12 col-lg-10 col-xl-11">
          <label class="mt-2" for="inputCapas">Visualizar agenda de:</label>
          <v-select
            class="style-chooser"
            v-model="capaSelecionada"
            @search="eventoDigitarBuscaPorCapa"
            :options="comboCapasDisponiveis"
            :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
            :filterable="false">
            <template v-slot:no-options>
              <em>Nenhum registro encontrado.</em>
            </template>
          </v-select>
          <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_profile_data.f_capas']}}</div>
        </div>
        <div class="form-group text-right col-sm-12 col-md-12 col-lg-2 col-xl-1">
          <b-button class="botoes" style="margin-top: 2.6rem;" variant="outline-primary btn-sm" @click="adicionarNaListagemDeCapas()" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Adicionar</b-button>
        </div>
        <default-table
          :items="dadosPerfil.f_capas"
          :fields="fieldsCapa"
          :busy="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
          :tbody-tr-class="tabelaSemRegistros">
          <template #empty>
            <em>Nenhum registro encontrado.</em>
          </template>
          <template #cell(opcoes)="row">
            <b-button class="botoes" variant="outline-danger btn-sm" title="Excluir" @click="excluirDaListagemDeCapas(row.item)" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </template>
        </default-table>
      </div>
    </div>
      <label class="mt-2" for="inputQuemMeVisualiza">Quem me visualiza</label>
      <default-table
        :items="dadosPerfil.f_users_view"
        :fields="fieldsQuemMeVisualiza"
        :tbody-tr-class="tabelaSemRegistros">
        <template #empty>
          <em>Nenhum registro encontrado.</em>
        </template>
      </default-table>
    <div class="agrupamento col-xl-12">
      <div class="form-row col-xl-12">
        <div class="form-group col-sm-12 col-md-12 col-lg-10 col-xl-11">
          <label class="mt-2" for="inputAreas">Permitir atribuir responsabilidade para:</label>
          <treeSelect
            placeholder=""
            @select="selecionarOpcaoComboAcoes"
            v-model="idOpcaoComboAcoes"
            :async="true"
            :cacheOptions="false"
            loadingText="Carregando"
            noResultsText="Nenhum resultado encontrado"
            :backspaceRemoves="false"
            searchPromptText="Informe um termo para busca"
            :load-options="eventoDigitarBuscaPorTiposAcao"
            :autoLoadRootOptions="false"
            :disableFuzzyMatching="true"
          />
          <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_profile_data']}}</div>
        </div>
        <div class="form-group text-right col-sm-12 col-md-12 col-lg-2 col-xl-1">
          <b-button class="botoes" style="margin-top: 2.9rem;" variant="outline-primary btn-sm" @click="adicionarNaListagemDeTiposAcao()" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Adicionar</b-button>
        </div>
        <default-table
          :items="dadosPerfil.f_actiontypes"
          :fields="fieldsTiposAcao"
          :busy="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
          :tbody-tr-class="tabelaSemRegistros">
          <template #empty>
            <em>Nenhum registro encontrado.</em>
          </template>
          <template #cell(f_actiontype_name)="row">
            <template v-if="row.item.f_area_name !== '[]'">
              [{{ row.item.f_area_name }}] {{ row.item.f_actiontype_name }}
            </template>
            <template v-else>
              {{ row.item.f_actiontype_name }}
            </template>
          </template>
          <template #cell(opcoes)="row">
            <b-button class="botoes" variant="outline-danger btn-sm" title="Excluir" @click="excluirDaListagemDeTiposAcao(row.item)" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </template>
        </default-table>
      </div>
    </div>
  </div>
</template>

<script>
import Advogado from '../layoutPerfil/js/advogado'
export default Advogado
</script>

<style scoped>
@import "../layoutPerfil/scss/advogado.scss";
</style>
